import {encodeB64Unicode} from "@/util/stringUtils";
import {SlideGenerationMode} from "@/util/generationModeEnum";
import { PDFPage} from "@/models/ai/PDFPage";
import {VideoChapter} from "@/models/ai/videoDescription.model";

export type DocumentItem =
  | { type: 'PDF_PAGE', data: PDFPage }
  | { type: 'VIDEO_SECTION', data: VideoChapter };

export class WeetInitiator {
  documents: DocumentItem[]=[];
  hiddenInstructionB64:string|null=null;
  lang:string|null=null;
  ttl:number|null=null;
  generationMode=SlideGenerationMode.ENHANCED
  auto:boolean=false;
  // Style choices picked at speach-front's Style step. Passed as strings
  // (the AIAvatar / AIBackground / AIVoice enum values) — speacher_front
  // reads them and dispatches the matching SELECT_AI_AVATAR / _BACKGROUND /
  // _VOICE store actions.
  avatar:string|null=null;
  background:string|null=null;
  voice:string|null=null;
  // Image generation style — prompt suffix (see LIST_OF_IMAGE_STYLES).
  // speacher_front dispatches SAVE_STYLE_IMAGEGENERATION with this value.
  imageStyle:string|null=null;
  // Key of the visual template picked at the Style step (see
  // LIST_OF_VISUAL_TEMPLATES). Forwarded to speacher_front for reference.
  visualTemplate:string|null=null;
  // Whitelist of SlideTemplate values the generator is allowed to use.
  // Empty = all allowed. Populated from the template's allowedSlideTemplates.
  // Blocking enforcement is planned in a follow-up step on speacher_front.
  allowedSlideTemplates:string[]=[];
  // Toggle from the Style step. When false, speach-llm skips the automatic
  // videoAnnotations generation for this weet. Default true.
  annotationsEnabled:boolean=true;
  // Per-subchapter auto video generation flag. Currently true only for
  // subchapters of type EXPLAINER (driven by SUB_CHAPTER_TYPE_CONFIG).
  autoVideoGeneration:boolean=false;
  constructor(documents:DocumentItem[],generationMode:SlideGenerationMode,hiddenInstruction:string|null=null,
              lang:string|null=null, ttl:number|null=null) {
    this.lang=lang;
    this.documents=documents;
    this.generationMode=generationMode;
    if(hiddenInstruction) {
      this.hiddenInstructionB64 = encodeB64Unicode(hiddenInstruction);
    }
    this.ttl=ttl;
  }
}
